
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from './Title/index.vue'

@Component({
  components: {
    Title
  }
})
export default class Book extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
